import * as React from 'react';
import { createElement as el } from 'react';

import { DataAttributes } from '../utils/DataAttributes';
import { PreventUserSelectSansCursor } from '../styles/PreventUserSelect';

const BlockStyle: React.CSSProperties = {
  boxSizing: 'border-box',
  position: 'relative',
  margin: 0,
  padding: 0,
  lineHeight: 'normal'
};

/**
 * @deprecated use regular old `div` instead
 */
export class Block extends React.Component<React.HTMLAttributes<HTMLDivElement> & DataAttributes, {}> {
  public render(): JSX.Element {
    return el('div', { ...this.props, style: { ...BlockStyle, ...this.props.style } });
  }
}

/**
 * @deprecated use regular old `div` instead
 */
export class InlineBlock extends React.Component<React.HTMLAttributes<HTMLDivElement> & DataAttributes, {}> {
  public render(): JSX.Element {
    return el('div', { ...this.props, style: { ...BlockStyle, display: 'inline-block', ...this.props.style } });
  }
}

export class Img extends React.Component<React.ImgHTMLAttributes<HTMLImageElement> & DataAttributes, {}> {
  public render(): JSX.Element {
    return el('img', {
      alt: '', // TFSID 942018
      role: 'presentation',
      ...this.props,
      style: { ...PreventUserSelectSansCursor, flexShrink: 0, ...this.props.style }
    }
    );
  }
}
